import { AfterViewInit, Component, OnInit, ViewChild, inject } from "@angular/core";
import { AsyncPipe } from "@angular/common";
import { TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/controls/i18n/scope";
import { TabModel } from "@models/generic/TabModels/TabModel";
import { LinkedRiskModel } from "../shared/models";
import { EffDetailWorkflowHistoryComponent } from "./eff-detail-workflow-history/eff-detail-workflow-history.component";
import { AdvEffDataService } from "../shared/services";
import { TabService } from "@services/tabs/TabService";
import { Pages } from "@constants/pages/Pages";
import { Observable } from "rxjs";
import { CerrixLoaderComponent } from "@app/shared/components/cerrix-loader/cerrix-loader.component";
import { MenuSystemDirective } from "@app/shared/directives/menu-system.directive";
import { EffDetailMainComponent } from "./eff-detail-main/eff-detail-main.component";
import { LinkedRisksComponent } from "./linked-risks/eff-linked-risks.component";

@Component({
    selector: "eff-detail",
    templateUrl: "./eff-detail.component.html",
    styleUrls: ["./eff-detail.component.scss"],
    imports: [
        CerrixLoaderComponent,
        MenuSystemDirective,
        TranslatePipe,
        AsyncPipe,
        EffDetailMainComponent,
        LinkedRisksComponent,
        EffDetailWorkflowHistoryComponent,
    ],
    viewProviders: [provideTranslationScope(scope)]
})
export class EffDetailComponent implements OnInit, AfterViewInit {
    private advancedTestingService = inject(AdvEffDataService);
    private tabService = inject(TabService);
    private pages = inject(Pages);

    tab: TabModel;

    effectivenessGuid: string;
    linkedRisks$: Observable<LinkedRiskModel[]>;

    @ViewChild("workflowHistory") workflowHistoryComp: EffDetailWorkflowHistoryComponent;

    ngOnInit() {
        this.effectivenessGuid = this.tab.id;
        this.tab.showLoader = false;
    }

    ngAfterViewInit() {
        var element = document.querySelector(`.tab-page:not([hidden])`);
        if (element) {
            element.classList.add("control-testing-details-tab-page");
        }
    }

    onMenuItemClick(menuItem) {
        switch (menuItem.menuItemId) {
            case "Risks": {
                if (!this.linkedRisks$) {
                    this.linkedRisks$ = this.advancedTestingService.getLinkedRisks(
                        this.effectivenessGuid
                    );
                }
                break;
            }
            case "Workflow history": {
                this.workflowHistoryComp.init();
                break;
            }
        }
    }

    openRisk(risk: LinkedRiskModel) {
        const trimmedIdentifier = risk.identifier.replace(/^0+/g, "");
        this.tabService.generateTab(
            this.pages.RiskDetail,
            risk.guid,
            `(R) ${trimmedIdentifier} - ${risk.name}`
        );
    }
}
